import React from "react";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";

/**
 *
 * This component handles the Collapse Duplicates functionality. It is essentially just a
 * checkbox with an enabled/disabled state and an onChange callback function.
 * Note that the logic of the "enabled" param is backwards from a checkbox point of view.
 * See propTypes for param details.
 * This component holds no state.
 */
function CollapseDuplicatesInput({
  enabled,
  onCollapseDuplicateChanged,
  intl
}) {
  return (
    <div className="collapse-duplicates-input">
      <label htmlFor="collapse-duplicates-toggle">
        <input
          type="checkbox"
          id="collapse-duplicates-toggle"
          onChange={onCollapseDuplicateChanged}
          checked={!enabled}
        />
        <span>
          {intl.formatMessage({
            id: "alpha.collapseDuplicates"
          })}
        </span>
      </label>
    </div>
  );
}

CollapseDuplicatesInput.propsTypes = {
  // Enabled when duplicates should NOT be shown
  // Meaning, if you want the checkbox "on", this
  // param should be false
  enabled: PropTypes.bool.isRequired,
  // injected by injectIntl
  intl: PropTypes.object.isRequired,
  // The onChange callback function
  onCollapseDuplicateChanged: PropTypes.func
};

export default injectIntl(CollapseDuplicatesInput);
